<template>
    <div class="tsa-orderCancelSuccessDialog" v-show="show" :class="type ? 'className-'+type: ''">
        <div class="mask"></div>
        <div class="content">
            <span class="el-icon-close" @click="close"></span>
            <img class="icon" src="../../assets/images/order_success.png" alt="">
            <h3>订单取消成功</h3>
            <!-- tip上的取消成功提示 -->
            <div class="bottom-1" v-show="type === 1">
                <img class="banner" v-if="cancelOrder.imageUrl" @click="action(cancelOrder)" :src="cancelOrder.imageUrl" alt="">
                <div class="btn" @click="close" v-else>
                    <p>确定</p>
                </div>
            </div>
            <!-- 订单待支付列表的取消成功提示 -->
            <div class="bottom-2" v-show="type === 2">
                <div class="packageType-container">
                    <p class="tip">您还可以购买</p>
                    <TsaPackageTypeList ref="TsaPackageTypeList" @serviceBuy="serviceBuy"></TsaPackageTypeList>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import router from '../../router/index'
import TsaPackageTypeList from '../../views/layout/components/packageTypeList.vue'
import { getAdBannerApi } from "@http/website/index"
export default {
    components: {
        TsaPackageTypeList,
    },
    data () {
        return {
            show: false,
            show1: false,
            type: 1, // 1是tip上的取消成功提示 2 订单待支付列表的取消成功提示
            traceMap: {},
            cancelOrder: {}
        }
    },
    watch: {
        show (val) {
            if (val) {
                this.init()
            }
        }
    },
    methods: {
        init () {
            if (this.type === 1) {
                if (this.cancelOrder.id) {
                    return
                }
                getAdBannerApi({locations: 11}).then(({ cancelOrder }) => {
                    this.cancelOrder = cancelOrder || {}
                })
            } else if (this.type === 2) {
                this.$refs.TsaPackageTypeList.dealListCommon()
            }
        },
        serviceBuy (item) {
            this.show = false
            zhuge.track('用户中心_订单列表_待支付订单_取消订单-弹窗', {
                '服务包名称': item.name
            }) 
            router.push({path: '/userAccount/buy', query: {suiteId: item.id}})
        },
        close () {
            this.show = false
        },
        action (item) {
            this.show = false
            // 当前页面跳转 1是当前页面 0是新开页面
            let traceName = '用户中心_弹窗广告位'
            let traceMap = {
                '广告位名称': item.name,
                '页面名称': this.traceMap.page
            }
            if (item.openType === 1) {
                zhuge.track(traceName, traceMap, () => {
                    // 此处不用判断首付登录
                    window.location.href = item.hrefUrl
                })
            } else {
                zhuge.track(traceName, traceMap)
                window.open(item.hrefUrl, '_blank')
            }
        }
    }
}
</script>

<style lang="less" scoped>
    .tsa-orderCancelSuccessDialog {
        position: fixed;
        width: 100%;
        height: 100%;
        top: 0;
        left: 0;
        z-index: 999;
        &.className-2 {
            .content {
                padding-top: 34px;
            }
        }
        .mask {
            position: absolute;
            width: 100%;
            height: 100%;
            top: 0;
            left: 0;
            background: #0D0D0D;
            opacity: 0.5;
            z-index: 1;
        }
        .content {
            position: absolute;
            width: 520px;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
            background: #fff;
            box-shadow: 0px 4px 12px 1px rgba(7,12,20,0.12);
            border-radius: 12px;
            padding: 60px 30px 25px 30px;
            box-sizing: border-box;
            z-index: 2;
            box-sizing: border-box;
            display: flex;
            flex-direction: column;
            align-items: center;
            .el-icon-close {
                position: absolute;
                right: 22px;
                top: 22px;
                cursor: pointer;
                color: #8E9095;
                font-size: 20px;
                &:hover {
                    color: #005CE6;
                }
            }
            .icon {
                width: 60px;
                height: 60px;
                margin-bottom: 24px;
            }
            h3 {
                font-weight: bold;
                font-size: 20px;
                color: #151B26;
                line-height: 24px;
                margin-bottom: 30px;
            }
            .bottom-1 {
                width: 100%;
                display: flex;
                justify-content: center;
                flex-direction: column;
                align-items: center;
                .banner {
                    width: 100%;
                    height: 264px;
                    object-fit: cover;
                    cursor: pointer;
                    border-radius: 8px;
                }
            }
            .bottom-2 {
                width: 100%;
                display: flex;
                justify-content: center;
                flex-direction: column;
                align-items: center;
                .packageType-container {
                    width: 100%;
                    height: 181px;
                    display: flex;
                    justify-content: center;
                    flex-direction: column;
                    align-items: center;
                    background: rgba(230,240,255,0.49);
                    border-radius: 8px;
                    padding-top: 6px;
                    .tip {
                        font-weight: bold;
                        font-size: 14px;
                        color: #151B26;
                        line-height: 24px;
                        margin-bottom: 16px;
                    }
                    /deep/.package-type-list {
                        .package-type {
                            ul {
                                li {
                                    width: 190px;
                                    min-width: auto;
                                    &:hover {
                                        background: #F9F0FE;
                                    }
                                    &:first-child {
                                        margin-right: 22px;
                                    }
                                }
                            }
                        }
                    }
                }
            }
            .btn {
                width: 120px;
                height: 40px;
                display: flex;
                justify-content: center;
                align-items: center;
                background: #FFFFFF;
                border-radius: 6px;
                border: 1px solid #005CE6;
                margin-top: 15px;
                margin-bottom: 15px;
                cursor: pointer;
                &:hover {
                    background: #faf9f9;
                }
                p {
                    font-size: 14px;
                    color: #2468F2;
                }
            }
        }
    }
</style>